module.exports = __webpack_public_path__ + "static/media/sendEmailIcon.8f734714.svg";